import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "ui dropdown custom branch-selector-dropdown ellipsis-items-nowrap" }
const _hoisted_2 = { class: "flex-text-block gt-ellipsis" }
const _hoisted_3 = { class: "ui icon search input" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "branch-tag-tab"
}
const _hoisted_7 = {
  class: "scrolling menu",
  ref: "scrollContainer"
}
const _hoisted_8 = {
  key: 0,
  class: "loading-indicator is-loading"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "ui label"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "text small" }
const _hoisted_17 = ["action"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 1,
  class: "message"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      tabindex: "0",
      class: "ui button branch-dropdown-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuVisible = !_ctx.menuVisible))
    }, [
      _createElementVNode("span", _hoisted_2, [
        (_ctx.dropdownFixedText)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.dropdownFixedText), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.currentRefType === 'tag')
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    name: "octicon-tag"
                  }))
                : (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 1,
                    name: "octicon-git-branch"
                  })),
              _createElementVNode("strong", {
                ref: "dropdownRefName",
                class: "tw-ml-2 tw-inline-block gt-ellipsis"
              }, _toDisplayString(_ctx.currentRefShortName), 513 /* TEXT, NEED_PATCH */)
            ], 64 /* STABLE_FRAGMENT */))
      ]),
      _createVNode(_component_svg_icon, {
        name: "octicon-triangle-down",
        size: 14,
        "class-name": "dropdown icon"
      })
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["menu transition", {visible: _ctx.menuVisible}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", _hoisted_4, [
          _createVNode(_component_svg_icon, {
            name: "octicon-filter",
            size: 16
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "search",
          ref: "searchField",
          autocomplete: "off",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
          onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.keydown($event))),
          placeholder: _ctx.searchFieldPlaceholder
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5), [
          [_vModelText, _ctx.searchTerm]
        ])
      ]),
      (_ctx.showTabBranches)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("a", {
              class: _normalizeClass(["branch-tag-item muted", {active: _ctx.selectedTab === 'branches'}]),
              href: "#",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTabSwitch('branches')))
            }, [
              _createVNode(_component_svg_icon, {
                name: "octicon-git-branch",
                size: 16,
                "class-name": "tw-mr-1"
              }),
              _createTextVNode(_toDisplayString(_ctx.textBranches), 1 /* TEXT */)
            ], 2 /* CLASS */),
            (_ctx.showTabTags)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["branch-tag-item muted", {active: _ctx.selectedTab === 'tags'}]),
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleTabSwitch('tags')))
                }, [
                  _createVNode(_component_svg_icon, {
                    name: "octicon-tag",
                    size: 16,
                    "class-name": "tw-mr-1"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.textTags), 1 /* TEXT */)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "branch-tag-divider" }, null, -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_svg_icon, {
          name: "octicon-rss",
          "symbol-id": "svg-symbol-octicon-rss"
        }),
        (_ctx.tabLoadingStates[_ctx.selectedTab] === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.refShortName,
            class: _normalizeClass(["item", {selected: item.selected, active: _ctx.activeItemIndex === index}]),
            onClick: ($event: any) => (_ctx.selectItem(item)),
            ref_for: true,
            ref: 'listItem' + index
          }, [
            _createTextVNode(_toDisplayString(item.refShortName) + " ", 1 /* TEXT */),
            (item.refType === 'branch' && item.refShortName === _ctx.currentRepoDefaultBranch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.textDefaultBranchLabel), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.enableFeed && _ctx.selectedTab === 'branches')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  role: "button",
                  class: "rss-icon",
                  target: "_blank",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                  href: item.rssFeedLink
                }, [
                  _createCommentVNode(" creating a lot of Vue component is pretty slow, so we use a static SVG here "),
                  _cache[7] || (_cache[7] = _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    class: "svg octicon-rss"
                  }, [
                    _createElementVNode("use", { href: "#svg-symbol-octicon-rss" })
                  ], -1 /* HOISTED */))
                ], 8 /* PROPS */, _hoisted_11))
              : _createCommentVNode("v-if", true)
          ], 10 /* CLASS, PROPS */, _hoisted_9))
        }), 128 /* KEYED_FRAGMENT */)),
        (_ctx.showCreateNewRef)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["item", {active: _ctx.activeItemIndex === _ctx.filteredItems.length}]),
              ref: 'listItem' + _ctx.filteredItems.length,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createNewRef()))
            }, [
              (_ctx.selectedTab === 'tags')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_svg_icon, {
                      name: "octicon-tag",
                      class: "tw-mr-1"
                    }),
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.textCreateTag.replace('%s', _ctx.searchTerm))
                    }, null, 8 /* PROPS */, _hoisted_13)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_svg_icon, {
                      name: "octicon-git-branch",
                      class: "tw-mr-1"
                    }),
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_ctx.textCreateBranch.replace('%s', _ctx.searchTerm))
                    }, null, 8 /* PROPS */, _hoisted_15)
                  ])),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.textCreateRefFrom.replace('%s', _ctx.currentRefShortName)), 1 /* TEXT */),
              _createElementVNode("form", {
                ref: "createNewRefForm",
                method: "post",
                action: _ctx.createNewRefFormActionUrl
              }, [
                _createElementVNode("input", {
                  type: "hidden",
                  name: "_csrf",
                  value: _ctx.csrfToken
                }, null, 8 /* PROPS */, _hoisted_18),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "new_branch_name",
                  value: _ctx.searchTerm
                }, null, 8 /* PROPS */, _hoisted_19),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "create_tag",
                  value: String(_ctx.selectedTab === 'tags')
                }, null, 8 /* PROPS */, _hoisted_20),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "current_path",
                  value: _ctx.currentTreePath
                }, null, 8 /* PROPS */, _hoisted_21)
              ], 8 /* PROPS */, _hoisted_17)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */),
      (_ctx.showNoResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.textNoResults), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.showViewAllRefsEntry)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider tw-m-0" }, null, -1 /* HOISTED */)),
            (_ctx.selectedTab === 'branches')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "item",
                  href: _ctx.currentRepoLink + '/branches'
                }, _toDisplayString(_ctx.textViewAllBranches), 9 /* TEXT, PROPS */, _hoisted_23))
              : _createCommentVNode("v-if", true),
            (_ctx.selectedTab === 'tags')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "item",
                  href: _ctx.currentRepoLink + '/tags'
                }, _toDisplayString(_ctx.textViewAllTags), 9 /* TEXT, PROPS */, _hoisted_24))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */), [
      [_vShow, _ctx.menuVisible]
    ])
  ]))
}